import { Decoration_Type } from 'ricos-types';
import { decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { RESOLVERS_IDS } from 'wix-rich-content-toolbars-v3/libs/resolvers-ids';
import { TEXT_COLOR_MODAL_ID, TEXT_HIGHLIGHT_MODAL_ID } from './constants.js';
import { TEXT_COLOR_TOOLBAR_BUTTON, TEXT_HIGHLIGHT_TOOLBAR_BUTTON } from './dataHooks.js';
import TextColorIcon from './icons/TextColorIcon.js';
import TextHighlightIcon from './icons/TextHighlightIcon.js';
import { TextColorPicker } from './TextColorPicker.js';
import 'react';
import 'ricos-context';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';

const getTextColorTextButtons = (config = {}) => {
  return [
    {
      id: `${Decoration_Type.COLOR}.foreground`,
      type: "modal",
      presentation: {
        dataHook: TEXT_COLOR_TOOLBAR_BUTTON,
        tooltip: "TextColorButton_Tooltip",
        getIcon(editorCommands) {
          const color = editorCommands.getColor("ricos-text-color");
          return () => TextColorIcon({ color });
        }
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        selectedTextColor: RESOLVERS_IDS.GET_TEXT_COLOR_IN_SELECTION,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED
      },
      commands: {
        setTextColor: ({ editorCommands }) => (color) => {
          editorCommands.chain().focus().setColor(color.color).run();
        },
        resetTextColor: ({ editorCommands }) => () => {
          editorCommands.chain().focus().unsetColor().run();
        }
      },
      modal: {
        id: TEXT_COLOR_MODAL_ID,
        Component: decorateComponentWithProps(TextColorPicker, {
          type: "ricos-text-color",
          config
        }),
        noPadding: true
      }
    }
  ];
};
const getTextHighlightTextButtons = (config = {}) => {
  return [
    {
      id: `${Decoration_Type.COLOR}.background`,
      type: "modal",
      presentation: {
        dataHook: TEXT_HIGHLIGHT_TOOLBAR_BUTTON,
        tooltip: "TextHighlightButton_Tooltip",
        getIcon(editorCommands) {
          const color = editorCommands.getColor("ricos-text-highlight");
          return () => TextHighlightIcon({ color });
        }
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        selectedHighlightColor: RESOLVERS_IDS.GET_HIGHLIGHT_COLOR_IN_SELECTION,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED
      },
      commands: {
        setHighlightColor: ({ editorCommands }) => (color) => {
          editorCommands.chain().focus().setHighlight(color.color).run();
        },
        resetHighlightColor: ({ editorCommands }) => () => {
          editorCommands.chain().focus().unsetHighlight().run();
        }
      },
      modal: {
        id: TEXT_HIGHLIGHT_MODAL_ID,
        Component: decorateComponentWithProps(TextColorPicker, {
          type: "ricos-text-highlight",
          config
        }),
        noPadding: true
      }
    }
  ];
};

export { getTextColorTextButtons, getTextHighlightTextButtons };
//# sourceMappingURL=getTextButtons.js.map
